import { ProjectDetailState } from '../state';
import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Environment } from 'data/terra/Environment';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store/reducer';
import { selectAppConfig } from './SelectAppConfig';

export const selectEnv =
  (env: Environment): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch, getState) => {
    dispatch({
      type: SELECT_ENV,
      selectedEnv: env,
    } as SelectEnvAction);

    const appConfigs = getState().projectDetail.appConfigs.data;
    appConfigs?.forEach((config) => {
      if (env.id === config.env.id) {
        dispatch(selectAppConfig(config));
      }
    });
  };

const SELECT_ENV = 'project/environments/select';

export interface SelectEnvAction {
  type: typeof SELECT_ENV;
  selectedEnv: Environment;
}

export const selectEnvDelegate: DelegateMapEntry<
  SelectEnvAction,
  ProjectDetailState
> = {
  [SELECT_ENV]: (
    state: ProjectDetailState,
    action: SelectEnvAction
  ): ProjectDetailState => {
    return {
      ...state,
      selectedEnv: action.selectedEnv,
    };
  },
};
